import queryString from 'query-string'
import api from '@utils/api'
import {http} from '@utils'
import moment from 'moment'
import md5 from 'md5'

const bizType = 2
const sign = '1a1a63bfbc354b02af7dcd7e052ae828'

// 获取一个随机的三位数
function randomThree() {
  let randT = ''
  for(let i = 0; i<3;i++) {
    let r = Math.floor(Math.random()*10)
    if(r != 0) {
      randT += r
    }
  }
  return randT
}

export default {
  namespaced: true,
  state: {
    menuList:[], // 菜单列表
    courseTotal:0, //课程总数
    courseList:[], //课程列表
    searchWord:'', //搜索热词
    searchFailedWord: '', //搜索失败热词
    linkCargoryId:'', //菜单ID
    linkTitle: '', // 菜单标题
    hotWords:[], //搜索热词
    openKeys:[], //侧边栏一级节点数组
    page:1,
    limit:10
  },
  mutations: {
    setMutations(state, {data, nameSpace}) {
      state[nameSpace] = data
    }
  },
  actions:{
    // 获取菜单数据
    async getCategoryTreeData({ commit }) {
      let params = {
        bizType,
        sign
      }
      const res = await http.get(`${api.adwords}/hbp-college/category/manager/categoryTreeData.do?${queryString.stringify(params)}`)
      commit('setMutations', {data:res.data,nameSpace:'menuList'})
    },
    // 获取课程列表
    async queryCourseList({ commit }, params) {
      params.sign = sign
      params['pojo.bizType'] = bizType
      params.page = this.state.adwords.page
      params.limit = this.state.adwords.limit
      const res = await http.post(`${api.adwords}/hbp-college/course/manager/queryCourseList.do`, queryString.stringify( params ), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
      if (res.code == 0 && Array.isArray(res.data) && res.data.length > 0) {
        commit('setMutations', {data:res.data, nameSpace:'courseList'})
        commit('setMutations', {data:res.count, nameSpace:'courseTotal'})
      } else {
        if (params['pojo.courseName']) {
          commit('setMutations', {data:params['pojo.courseName'], nameSpace:'searchFailedWord'})
        } else if (params['pojo.linkCargoryId']) {
          commit('setMutations', {data:this.state.adwords.linkTitle, nameSpace:'searchFailedWord'})
        } else  {
          commit('setMutations', {data:'广告产品', nameSpace:'searchFailedWord'})
        }
        commit('setMutations', {data:[], nameSpace:'courseList'})
        commit('setMutations', {data:0, nameSpace:'courseTotal'})
      }
    },
    // 获取课程明细(无登录状态)
    async queryCourseById({ commit }, params) {
      let randT = randomThree()
      let nowDate = moment(new Date()).valueOf()
      params.sign = sign
      params.random = randT
      params.timeStamp = nowDate
      params.token = md5(`${randT}${nowDate}${sign}vXKe$0^qe0Wsc%oC`)
      const res = await http.get(`${api.adwords}/hbp-college/course/manager/queryCourseByIdSign.do?${queryString.stringify(params)}`)
      return res
    },
    // 获取搜索热词
    async queryAdwordsHotWords({commit}) {
      const res = await http.get(`${api.cmsHost}/publish/976/adwordsHotWords.json`)
      if (res.code == 0 && res.data && Array.isArray(res.data.hotWords)) {
        commit('setMutations', {data:res.data.hotWords, nameSpace:'hotWords'})
      }
    }
  }
}

